import { render, staticRenderFns } from "./adGameDataCount.vue?vue&type=template&id=2f875406&"
import script from "./adGameDataCount.vue?vue&type=script&lang=js&"
export * from "./adGameDataCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f875406')) {
      api.createRecord('2f875406', component.options)
    } else {
      api.reload('2f875406', component.options)
    }
    module.hot.accept("./adGameDataCount.vue?vue&type=template&id=2f875406&", function () {
      api.rerender('2f875406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/payAnalysis/adGameDataCount.vue"
export default component.exports